export enum UnsplashTableActionUiEnum {
  DOWNLOAD = 'DOWNLOAD',
  ADD = 'ADD',
  RESET = 'RESET',
}
